import { render } from "./OccupationalInjuryLevelAlysis.vue?vue&type=template&id=b13a3024&scoped=true"
import script from "./OccupationalInjuryLevelAlysis.vue?vue&type=script&lang=js"
export * from "./OccupationalInjuryLevelAlysis.vue?vue&type=script&lang=js"

import "./OccupationalInjuryLevelAlysis.vue?vue&type=style&index=0&id=b13a3024&lang=scss&scoped=true"
import "./OccupationalInjuryLevelAlysis.vue?vue&type=style&index=1&id=b13a3024&lang=scss&scoped=true"
import "./OccupationalInjuryLevelAlysis.vue?vue&type=style&index=2&id=b13a3024&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13a3024"]])

export default __exports__